import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const telegramAdminStatsDataSchema = z.object({
  users: z.object({
    total: z.number(),
    newToday: z.number(),
    newThisWeek: z.number(),
    activeSessions: z.number(),
  }),
  reviews: z.object({
    total: z.number(),
    today: z.number(),
    thisWeek: z.number(),
  }),
});

export type ITelegramAdminStatsData = z.infer<typeof telegramAdminStatsDataSchema>;

export const telegramAdminStatsResponseSchema = createApiResponseSchema(
  telegramAdminStatsDataSchema,
) as z.ZodSchema<IAPI<ITelegramAdminStatsData>>;

export type ITelegramAdminStatsResponse = IAPI<ITelegramAdminStatsData>;
